import React from 'react';
import FeaturedImage from '../FeaturedImage';
import PostContentElement from '../PostContentElement';

function alumni(props) {
    const {
        post,
        postType,
        acfData,
    } = props;

    let title;
    let categories;
    let categoryItems;
    let featuredImage;
    let categoriesElement;
    let programsElement;
    let whatILoveElement;
    let requestButtonElement;
    let requestButton = post.acf_single_request_an_introduction ? post.acf_single_request_an_introduction : acfData.acf_alumni_request_button;

    console.log(post);

    if (post.hasOwnProperty('featured_image') && post.featured_image) {
        featuredImage =
            <figure className='alumni-post__featured-image'>
                <FeaturedImage
                    imageSize={'alumni-image'}
                    image={post.featured_image}
                    srcset={post.featured_image}
                ></FeaturedImage>
            </figure>
    }
    
    if (post.hasOwnProperty('acf_single_display_name') && post.acf_single_display_name) {
        title = post.acf_single_display_name;
    } else {
        title = post.title.rendered;
    }

    if (post.hasOwnProperty('the_categories') && post.the_categories.length > 0) {
        categories = post.the_categories;
    }

    if (categories) {
        categoryItems = categories.map((category, index) => {

            if (category.taxonomy === 'alumni_school') {
                return (
                    <span
                        className="alumni-post__content-item-text"
                        key={index}
                    >{category.name}</span>
                );
            }

        });
        categoriesElement = <div className="alumni-post__content-item">
            <p className="alumni-post__content-item-label">College</p>
            <p className="alumni-post__content-item-text">
                {categoryItems}
            </p>
        </div>
    }

    if (post.acf_single_program && post.acf_single_program.length > 0) {
        programsElement = <PostContentElement
            content={post.acf_single_program}
            label='Atlantis Program'
        ></PostContentElement>
    }
    if (post.acf_single_what_i_love_about_atlantis && post.acf_single_what_i_love_about_atlantis.length > 0) {
        whatILoveElement = <PostContentElement
            content={post.acf_single_what_i_love_about_atlantis}
            label='What I love about Atlantis'
        ></PostContentElement>
    }
    if (requestButton) {
        const link_url = requestButton.url;
        const link_title = requestButton.title;
        const link_target = requestButton.target ? '_blank' : '_self';

        requestButtonElement = <a
            className="c-btn c-btn-primary c-btn-color-normal"
            href={link_url}
            target={link_target}><span>{link_title}</span></a>
    }

    return (
        <article id={`${postType}-${post.id}`} className="alumni-post" >
            <div className="alumni-post__wrapper">
                {featuredImage}
                <div className="alumni-post__content">
                    <h4 className="alumni-post__title" dangerouslySetInnerHTML={{ __html: title }} />
                    {categoriesElement}
                    {programsElement}
                    {whatILoveElement}
                    {requestButtonElement}
                </div>
            </div>
        </article>
    );
}

export default alumni;